import { useEffect } from 'react'
import { useTranslation } from "react-i18next"
import { useDispatch } from 'react-redux'
import { getProfile } from '../../actions/authActions'
import UserMenu from './UserMenu'
import CheckingWidget from '../CheckingWidget'

export default function Menu() {
	const { t } = useTranslation()
	const dispatch = useDispatch()

	useEffect(() => {
		dispatch(getProfile())
	}, [dispatch])

	return (
		<div className='cabecera d-flex justify-content-between align-items-center px-4 sticky-top'>
			<h5 className='fw-bold text-dark mb-0'>{t('global.portal')}</h5>
			<div className='d-flex align-items-center gap-3'>
				<CheckingWidget />
				<UserMenu />
			</div>
		</div>
	)
}
